import { Routes } from '@angular/router';
import { ReaderComponent } from './pages/reader/reader.component';
import { HomeComponent } from './pages/home/home.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { CamComponent } from './pages/cam/cam.component';

export const routes: Routes = [
  { path: '', component: ReaderComponent },
  { path: 'cam', component: CamComponent },
  { path: 'home', component: HomeComponent },
  { path: 'settings', component: SettingsComponent },
];
